<!-- 节目管理 -->
<template>
  <div class="program-management">
      <cs-form label-width="90px" class="header-search-box padding-t-20"
        form-width="100%"
        :form="searchParams"
        :formData="searchData"
        :form-col="searchFormCol"
        :inline="true">
        <template slot="search">
          <el-button type="primary" @click="search()">查询</el-button>
          <el-button type="primary" @click="exportList">导出Excel</el-button>
        </template>
      </cs-form>
      <div class="padding-b-20">
        <el-button @click="goUploadVideo()" type="primary">视频上传</el-button>
        <el-button @click="goBatchSendAudit()" type="primary">批量送审</el-button>
        <el-button @click="goBatchImport()" type="primary">批量编目导入</el-button>
        <el-button @click="goBatchDel()" type="primary">批量删除</el-button>
      </div>
      <cs-table ref="multipleTable" :tableCols="tableCols" class="no-shadow-table"
          :tableData="tableData"
          :paginationOption="paginationOption"
          :show-header="false"
          :row-class-name="tableRowClassName"
          @size-change="sizeChangeHandler"
          @current-change="currentPageHandler"
          @selection-change="selectionChange"
          @row-click="dbClick">
          <template slot-scope="scope" slot="imgUrl">
            <program-list type="20" project="vod" :data="scope.row">
              <tags-list v-if="scope.row.tagsList" :data="scope.row.tagsList" slot="title-slot"/>
            </program-list>
          </template>
      </cs-table>
    <DetailDialog v-if="isShow && tableData.length>0" ref="detailDialog" :imgUrl="imgUrl" :dialogData="dialogData" @refresh="getData(searchParams)" @closeHandle="closeHandle"/>
    <BatchImport ref="batchImportDataDialog"/>
  </div>
</template>
<script>
import { fetchPrograms, fetchCommonCategoryInuse, fetchProgramsDelete, fetchAuditProgram, getProgramPlayCount } from '@/resource/api/index'
import ProgramList from '@/components/ProgramList'
import TagsList from '@/components/TagsList'
import BatchImport from '@/views/common/dialog/batch-import-catalogue-vod.vue'
import DetailDialog from '@/views/common/dialog/program-detail.vue'
export default {
  components: {
    BatchImport, // 批量编目导入
    ProgramList,
    TagsList,
    DetailDialog // 编目详情
  },
  data () {
    return {
      isShow: false,
      imgUrl: '',
      searchParams: {
        limit: 20,
        offset: 1,
        operator: '',
        name: '',
        category: '',
        auditState: ''
      },
      categoryList: [], // 分类option
      tagsList: [],
      searchFormCol: { gutter: 10, sm: 12, md: 8, lg: 6 },
      tableCols: [
        { type: 'selection', width: 55 },
        { prop: 'imgUrl', label: '封面图', type: 'slot', align: 'left' }
      ],
      tableData: [],
      multipleSelection: [],
      paginationOption: {},
      dialogData: {},
      index: 0
    }
  },
  created () {
    this.searchParams.operator = this.$store.state.router.createBySuffix
    this.paginationOption['page-size'] = this.$store.state.pageLimit
    this.searchParams.limit = this.$store.state.pageLimit
    this.getData(this.searchParams)
    this.fetchDsataDictionarys()// 分类DATA
  },
  methods: {
    // 加载数据
    getData (data) {
      const that = this
      fetchPrograms(data).then((res) => {
        if (res.code == '1') {
          that.tableData = res.results
          // 获取分类data
          that.tableData.map((item) => {
            var tags = []
            if (item.sndCategory) {
              tags.push(item.category, item.sndCategory)
            } else if (item.category) {
              tags.push(item.category)
            }
            item.tagsList = tags
            item.playCount = null
            getProgramPlayCount({ programIds: item.id }).then((res) => {
              if (res.code == 1) {
                if (res.result[0]) {
                  item.playCount = res.result[0].playCount
                }
              }
            })
            return item
          })
          this.dialogData = {
            data: this.tableData[this.index],
            project: 'vod'
          }
          this.paginationOption = {
            ...this.paginationOption,
            'current-page': this.searchParams.offset,
            total: parseInt(res.total)
          }
        }
      })
    },
    fetchDsataDictionarys () {
      fetchCommonCategoryInuse({ createBy: this.$store.state.router.createBySuffix }).then((res) => {
        if (res.code == '1') {
          res.result.forEach((item) => {
            this.categoryList.push({ value: item, label: item })
          })
        }
      })
    },
    // 查询
    search () {
      this.currentPageHandler(1)
      this.isShow = false
    },
    // 获取选中数据
    selectionChange (selection) {
      this.multipleSelection = selection
    },
    sizeChangeHandler (val) {
      this.isShow = false
      this.searchParams.limit = val
      this.searchParams.offset = 1
      this.getData(this.searchParams)
    },
    currentPageHandler (val) {
      this.isShow = false
      this.searchParams.offset = val
      this.getData(this.searchParams)
    },
    selectChange (row) {
      // 查询下拉
      // console.log(row)
    },
    // 视频上传
    goUploadVideo () {
      this.$router.push({ name: 'uploadVideo' })
    },
    // 批量送审判断
    goBatchSendAudit () {
      if (this.multipleSelection.length == 0) {
        this.$message('还没有选中内容')
        return
      }
      this.batchSendAudit()
    },
    // 导出
    exportList () {
      const data = {
        name: this.searchParams.name,
        category: this.searchParams.category,
        auditState: this.searchParams.auditState ? this.searchParams.auditState : '',
        operator: this.searchParams.operator,
        limit: this.searchParams.limit,
        offset: this.searchParams.offset
      }
      this.$axios({
        // 跨域设置---------------------start
        async: true,
        crossDomain: true,
        withCredentials: true,
        headers: {
          AJAX: true
        },
        // 跨域设置---------------------end
        method: 'GET',
        url: process.env.VUE_APP_BASE_API_MGR + '/programsExport',
        params: data,
        responseType: 'blob',
        timeout: 1000 * 60 * 3
      }).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })

        const fileName = 'Excel_' + this.$moment(new Date()).format('YYYYMMDDHHmmss') +
        '.xls'
        const linkNode = document.createElement('a')

        linkNode.download = fileName // a标签的download属性规定下载文件的名称
        linkNode.style.display = 'none'
        linkNode.href = URL.createObjectURL(blob) // 生成一个Blob URL
        document.body.appendChild(linkNode)
        linkNode.click() // 模拟在按钮上的一次鼠标单击

        URL.revokeObjectURL(linkNode.href) // 释放URL 对象
        document.body.removeChild(linkNode)
      }).catch(err => {
        if (err.response && err.response.status == 601) {
          this.$message({
            type: 'error',
            message: '暂无数据可导出'
          })
        } else {
          this.$message({
            type: 'error',
            message: '程序异常'
          })
        }
      })
      // window.location.href = process.env.VUE_APP_BASE_API_MGR + `/programsExport?name=${this.searchParams.name}&category=${this.searchParams.category}&auditState=${this.searchParams.auditState}&operator=${this.searchParams.operator}&limit=${this.searchParams.limit}&offset=${this.searchParams.offset}`
    },
    // 批量送审
    batchSendAudit () {
      const id = []
      this.multipleSelection.forEach(item => {
        id.push(item.id)
      })
      const data = {
        auditState: 'AUDIT_ING',
        deleteFlag: 0,
        ids: id,
        memo: '',
        operator: this.$store.state.router.updateBySuffix
      }
      fetchAuditProgram(data).then((res) => {
        if (res.code == '1') {
          this.$message({
            message: res.msg,
            type: 'success'
          })
          this.currentPageHandler(1)
        }
      })
    },
    // 批量删除判断
    goBatchDel () {
      if (this.multipleSelection.length == 0) {
        this.$message('还没有选中内容')
        return
      }
      this.batchDel()
    },
    // 批量删除
    batchDel () {
      this.$confirm('此操作将删除此数据, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const id = []
          this.multipleSelection.forEach(item => {
            id.push(item.id)
          })
          const data = { id, updateBy: this.$store.state.router.updateBySuffix }
          fetchProgramsDelete(data).then((res) => {
            if (res.code == '1') {
              this.$message.success('删除成功！')
              this.currentPageHandler(1)
            }
          }).catch(() => {
            this.$refs.multipleTable.clearSelection()
          })
        })
    },
    // 批量编目导入
    goBatchImport () {
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.$refs.batchImportDataDialog.open()
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      // 把每一行的索引放进row
      row.index = rowIndex
    },
    dbClick (row, $event) {
      this.index = row.index
      console.log(row)
      this.dialogData = {
        data: this.tableData[this.index],
        project: 'vod',
        isShowEdit: (() => {
          if (row.auditState == 'AUDIT_NON' || row.auditState == 'AUDIT_NO_PASS' || row.auditState == 'RE_AUDIT_NO_PASS') {
            return true
          }
          return false
        })()
      }
      this.isShow = false
      this.imgUrl = this.tableData[this.index].video.videoImgPaths[0].imgPath
      this.$nextTick(() => {
        // 等待dom同步后打开模态框
        this.isShow = true
      })
    },
    closeHandle () {
      this.isShow = false
    }

  },
  computed: {
    searchData () {
      return [
        {
          prop: 'name',
          type: 'input',
          label: '标题：',
          placeholder: '请输入标题',
          clearable: true,
          labelWidth: '60px',
          col: [3, 3, 3]
        },
        {
          prop: 'category',
          type: 'select',
          label: '分类：',
          clearable: true,
          filterable: true,
          options: this.categoryList
        },
        {
          prop: 'auditState',
          type: 'select',
          label: '审核状态：',
          filterable: true,
          options: [
            { label: '全部', value: '' },
            { label: '未审核', value: 'AUDIT_NON' },
            { label: '初审驳回', value: 'AUDIT_NO_PASS' },
            { label: '复审驳回', value: 'RE_AUDIT_NO_PASS' },
            { label: '待初审', value: 'AUDIT_ING' },
            { label: '待复审', value: 'RE_AUDIT_ING' },
            { label: '复审通过', value: 'RE_AUDIT_PASS' }
          ]
        },
        { prop: 'search', type: 'slot', label: '' }
      ]
    }
  }
}
</script>
<style lang="less">

</style>
